import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { exchangeCodeForTokens, consumeExpectedBlingState } from '../utils/bling'
import { getConfig } from '../utils/storage'
import { CheckCircle2, AlertCircle, RefreshCw } from 'lucide-react'

export function BlingCallback() {
  const navigate = useNavigate()
  const [status, setStatus] = useState('trocando') // 'trocando' | 'ok' | 'erro'
  const [msg,    setMsg]    = useState('')

  useEffect(() => {
    // Guarda processado para evitar duplo disparo do React StrictMode
    if (window.__blingCallbackProcessed) return
    window.__blingCallbackProcessed = true

    const params   = new URLSearchParams(window.location.search)
    const code     = params.get('code')
    const stateUrl = params.get('state')
    const errorParam = params.get('error')

    // Limpa a query string imediatamente — code é one-time use; evita
    // reusar em F5 e evita vazar em logs/history.
    try { window.history.replaceState({}, '', window.location.pathname) } catch {}

    if (errorParam) {
      setStatus('erro')
      setMsg(`Bling recusou a autorização: ${errorParam}`)
      return
    }

    if (!code) {
      setStatus('erro')
      setMsg('Código de autorização não encontrado na URL.')
      return
    }

    // Valida o state (defesa anti-CSRF). Sem isso, atacante autoriza no
    // Bling dele e manda o code pro admin — exchangeCodeForTokens roda
    // e substitui os tokens pelos do atacante.
    const stateEsperado = consumeExpectedBlingState()
    if (!stateEsperado || stateEsperado !== stateUrl) {
      setStatus('erro')
      setMsg('State do OAuth não bate. Reinicie a conexão pelo Config (não abra o link do callback diretamente).')
      return
    }

    const { blingClientId, blingClientSecret } = getConfig()
    if (!blingClientId || !blingClientSecret) {
      setStatus('erro')
      setMsg('Client ID ou Client Secret não configurados. Volte para Config e preencha os campos antes de conectar.')
      return
    }

    exchangeCodeForTokens(code, blingClientId, blingClientSecret)
      .then(() => {
        setStatus('ok')
        setMsg('Bling conectado com sucesso! Redirecionando...')
        setTimeout(() => navigate('/config'), 2000)
      })
      .catch(err => {
        setStatus('erro')
        setMsg(err.message)
      })
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="card p-8 max-w-md w-full text-center space-y-4">
        {/* Logo Bling */}
        <div className="flex justify-center">
          <div className="w-12 h-12 rounded-xl bg-[#E8F4FF] flex items-center justify-center">
            <span className="text-[#0057B8] text-xl font-black">B</span>
          </div>
        </div>

        <h2 className="text-lg font-bold text-slate-800">Conexão com Bling</h2>

        {status === 'trocando' && (
          <>
            <RefreshCw size={32} className="mx-auto text-[#0057B8] animate-spin" />
            <p className="text-sm text-slate-500">Trocando código de autorização por tokens...</p>
          </>
        )}

        {status === 'ok' && (
          <>
            <CheckCircle2 size={32} className="mx-auto text-green-500" />
            <p className="text-sm text-green-600 font-medium">{msg}</p>
          </>
        )}

        {status === 'erro' && (
          <>
            <AlertCircle size={32} className="mx-auto text-red-500" />
            <p className="text-sm text-red-600">{msg}</p>
            <button onClick={() => navigate('/config')} className="btn-secondary text-sm mx-auto">
              Voltar para Config
            </button>
          </>
        )}
      </div>
    </div>
  )
}
